<script>
  import Icon from '../Icon/Icon.svelte';
  export let type = '',
    size = '',
    responsive = false;

  const getIconName = (type) => {
    switch (type) {
      case 'warning':
        return 'exclamation-triangle';
      case 'error':
        return 'exclamation-triangle';
      case 'info':
        return 'info-circle';
      default:
        return type;
    }
  };

  const iconName = getIconName(type);
  const iconSize = size === 'large' ? '' : '16px';
  const iconType = ['exclamation-triangle', 'info-circle', 'thumbs-up'].includes(iconName)
    ? 'solid'
    : 'regular';
</script>

<style lang="scss">
  @import '../../styles/settings/colors';
  @import '../../styles/settings/core';
  @import '../../styles/tools/media-query';

  .badge-container {
    width: spacing(4);
    height: spacing(4);
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-shrink: 0;

    &.responsive.small {
      width: spacing(3);
      height: spacing(3);
    }

    @include mq($from: tabletportrait) {
      &.responsive.large {
        width: spacing(6);
        height: spacing(6);
      }

      &.responsive.small {
        width: spacing(4);
        height: spacing(4);
      }
    }
  }

  .icon-error {
    background-color: $bright-red-30;
    fill: $red-50;
  }

  .icon-warning {
    background-color: $yellow-30;
    fill: $yellow-90;
  }

  .icon-info {
    background-color: $bright-blue-60;
    fill: $blue-40;
  }

  .icon-thumbs-up {
    background-color: $pink-30;
    fill: $orange-50;
  }

  .icon-headphones {
    background-color: $bright-blue-50;
    fill: $blue-40;
  }

  .icon-glasses {
    background-color: $bright-green-50;
    fill: $green-40;
  }
</style>

<div class="badge-container icon-{type} {size}" class:responsive>
  <Icon {iconName} size={iconSize} {iconType} />
</div>
